import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";
import { Checkbox } from "@/components/ui/checkbox";

// variant: "download" (contenuti digitali scaricabili) | "service" (servizi smart)
export const CheckoutConsents = ({ variant = "download", terms, setTerms, immediate, setImmediate, idPrefix = "checkout" }) => {
  const { t } = useI18n();
  const immediateKey = variant === "service" ? "consent.immediateService" : "consent.immediateDownload";
  return (
    <div className="mt-4 space-y-3" data-testid={`${idPrefix}-consents`}>
      <label className="flex items-start gap-2.5 cursor-pointer">
        <Checkbox data-testid={`${idPrefix}-consent-terms`} checked={terms} onCheckedChange={(v) => setTerms(!!v)} className="mt-0.5" />
        <span className="text-xs leading-relaxed text-brand-navy/70">
          {t("consent.termsA")}{" "}
          <Link to="/termini" target="_blank" className="text-brand-electric hover:underline font-medium">{t("legal.terms")}</Link>{" "}
          {t("consent.termsB")}{" "}
          <Link to="/privacy" target="_blank" className="text-brand-electric hover:underline font-medium">{t("legal.privacy")}</Link>{" "}
          {t("consent.and")}{" "}
          <Link to="/recesso-e-rimborsi" target="_blank" className="text-brand-electric hover:underline font-medium">{t("legal.refund")}</Link>.
        </span>
      </label>
      <label className="flex items-start gap-2.5 cursor-pointer">
        <Checkbox data-testid={`${idPrefix}-consent-immediate`} checked={immediate} onCheckedChange={(v) => setImmediate(!!v)} className="mt-0.5" />
        <span className="text-xs leading-relaxed text-brand-navy/70">{t(immediateKey)}</span>
      </label>
    </div>
  );
};

export default CheckoutConsents;
